(() => {
  'use strict';

  const gallerySelector = '.productView-nav[data-image-gallery-main]';
  const focusableMediaSelector = [
    '.olitans-product-media-link[href]',
    '.deferred-media__poster',
    '.product__xr-button',
    '.productView-thumbnail-link[type="button"]',
    'video[controls]',
    'model-viewer',
    'iframe'
  ].join(',');
  const mobileQuery = window.matchMedia('(max-width: 767px)');
  const galleryStates = new WeakMap();

  const setAttributeIfChanged = (element, name, value) => {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  };

  const syncSlides = (gallery) => {
    const slides = Array.from(gallery.querySelectorAll('.slick-slide'));
    if (!slides.length) return;

    const showOriginalGrid = !mobileQuery.matches;
    slides.forEach((slide) => {
      const isClone = slide.classList.contains('slick-cloned');
      const isVisible = !isClone && (showOriginalGrid || slide.classList.contains('slick-active'));

      setAttributeIfChanged(slide, 'aria-hidden', isVisible ? 'false' : 'true');
      setAttributeIfChanged(slide, 'tabindex', '-1');
      slide.querySelectorAll(focusableMediaSelector).forEach((control) => {
        setAttributeIfChanged(control, 'tabindex', isVisible && !control.disabled ? '0' : '-1');
      });
    });
  };

  const syncControls = (gallery) => {
    const previousLabel = gallery.dataset.galleryPreviousLabel || 'Previous';
    const nextLabel = gallery.dataset.galleryNextLabel || 'Next';

    gallery.querySelectorAll('.slick-prev').forEach((button) => {
      setAttributeIfChanged(button, 'aria-label', previousLabel);
    });
    gallery.querySelectorAll('.slick-next').forEach((button) => {
      setAttributeIfChanged(button, 'aria-label', nextLabel);
    });

    const counter = gallery.querySelector('.slick-counter');
    if (!counter) return;

    const originalSlides = Array.from(gallery.querySelectorAll('.slick-slide:not(.slick-cloned)'));
    const currentSlide = originalSlides.findIndex((slide) => slide.classList.contains('slick-current'));
    const current = Math.max(1, currentSlide + 1);
    const total = originalSlides.length || Number(gallery.dataset.mediaCount) || 1;
    const currentNode = counter.querySelector('.slick-counter--current');
    const totalNode = counter.querySelector('.slick-counter--total');

    if (currentNode && currentNode.textContent !== String(current)) currentNode.textContent = String(current);
    if (totalNode && totalNode.textContent !== String(total)) totalNode.textContent = String(total);

    const galleryLabel = gallery.dataset.galleryLabel || 'Media gallery';
    const ofLabel = gallery.dataset.galleryOfLabel || 'of';
    setAttributeIfChanged(counter, 'role', 'status');
    setAttributeIfChanged(counter, 'aria-live', 'polite');
    setAttributeIfChanged(counter, 'aria-atomic', 'true');
    setAttributeIfChanged(counter, 'aria-label', `${galleryLabel}: ${current} ${ofLabel} ${total}`);
  };

  const syncGallery = (gallery) => {
    syncSlides(gallery);
    syncControls(gallery);
  };

  const enhanceGallery = (gallery) => {
    if (!gallery || galleryStates.has(gallery)) return;

    const state = { frame: null };
    const scheduleSync = () => {
      if (state.frame !== null) return;
      state.frame = window.requestAnimationFrame(() => {
        state.frame = null;
        syncGallery(gallery);
      });
    };

    const observer = new MutationObserver(scheduleSync);
    observer.observe(gallery, {
      attributes: true,
      attributeFilter: ['aria-hidden', 'class'],
      childList: true,
      subtree: true
    });

    if (window.jQuery) {
      window.jQuery(gallery).on('init.olitansGallery reInit.olitansGallery afterChange.olitansGallery', scheduleSync);
    }

    galleryStates.set(gallery, { observer, scheduleSync, state });
    scheduleSync();
  };

  const init = (root = document) => {
    if (root.matches?.(gallerySelector)) enhanceGallery(root);
    root.querySelectorAll?.(gallerySelector).forEach(enhanceGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', () => {
      document.querySelectorAll(gallerySelector).forEach(syncGallery);
    });
  } else {
    mobileQuery.addListener(() => {
      document.querySelectorAll(gallerySelector).forEach(syncGallery);
    });
  }

  window.olitansProductGallery = { enhanceGallery, syncGallery };
})();
